<script lang="ts">
    import {Button,Col,Form,FormGroup,Input,Label,Row,} from "sveltestrap";
    import {  BasicFormInput, Cancel, Emailaddress, ExampleMultipleSelect, ExampleSelect, ExampleTextarea, Password, Submit } from "../../../../utils/Constant/Constant";
    import Card from "../../../Core/Card.svelte";
</script>
<Card headerTitle={BasicFormInput} cardHeaderprops="pb-0" cardFooterprops="text-end">
      <div slot="contentbody">
        <Form class="theme-form">
          <Row>
            <Col>
              <FormGroup>
                  <Label for="exampleFormControlInput1">{Emailaddress}</Label>
                  <Input
                  type="email" id="exampleFormControlInput1" 
                  placeholder="name@example.com"
                  />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
                <div class="mb-3">
                    <FormGroup>
                        <Label for="exampleInputPassword2">{Password}</Label>
                        <Input id="exampleInputPassword2"
                        type="password"
                        placeholder="Password"
                        />
                    </FormGroup>
                </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                  <Label for="exampleFormControlSelect9">{ExampleSelect}</Label>
                  <Input
                  type="select"
                  name="select"
                  class="digits"
                  value="1"
                  >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                  <Label for="exampleFormControlSelect3"
                  >{ExampleMultipleSelect}</Label
                  >
                  <Input id="exampleFormControlSelect3" 
                  type="select"
                  name="select"
                  class="digits"
                  value="1"
                  >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <Label>{ExampleTextarea}</Label>
                <Input type="textarea" />
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="contentfooter">
        <Button color="primary">{Submit}</Button>
        <Button color="light" type="reset">{Cancel}</Button>
      </div>
</Card>